<style lang="less" scoped>
.td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;}
table {border-collapse: collapse;width: 100%;}
/deep/.el-textarea .el-textarea__inner {width: 400px;}
/deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {border-radius: 50%;}
/deep/th {border: 1px solid #EBEEF5}
.sbox {display: flex;}
.sbox /deep/ .el-input {width: 400px;margin: 10px;}
.sbox /deep/ .el-button {height: 40px;margin: 10px;}
.btns {display: flex;justify-content: space-between;}
.btns .btnbox {padding: 10px;}
.btns .f_r {padding: 10px;line-height: 40px;}
.mydialog {
  /deep/ .el-dialog__header{background: #dddfdf;text-align: left;}
}
</style>

<template>
  <div>
    <div class="el-tablebox">
        <el-table ref="multipleTable"
          :data="tableData" tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe border :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{ background: '#F5F5F5', color: '#606266',
          textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="glid" label="上级ID" width="250"></el-table-column>
          <el-table-column prop="colname" label="列名"></el-table-column>
          <el-table-column prop="dispc" label="分类名" > </el-table-column>
          <el-table-column prop="name" label="模块名称"></el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="danger" @click="delfn(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    <div class="btns">
      <div class="btnbox">
        <el-button type="success" @click="dialogVisible = true">添加分类</el-button>
        <el-button class="btn-r" @click="batchDelete">批量删除</el-button>
      </div>
    </div>
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogVisible"
      :width="widthCSH"
      title="添加分类"
      class="mydialog">
      <ComboBox :selectList="selectList" @addSelect="onSubmit" @onRemove="cancle"></ComboBox>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ComboBox from './ComboBox.vue'
import '../method/dialog.js'
export default {
  components: {
    ComboBox
  },
  props: ['minor'],
  data()
  {
    return {
      curid: null,
      //关键词
      input_keywords: '',
      tableData: [],
      tempId: [],
      dialogVisible: false,
      widthCSH: '36%',
      selectList: [{value: 'catid', name: '所属分类', parentdispc: '', dispc: '', tableData: []}]
    }
  },
  // 根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        this.curid = nval
        this.getData(nval)
      },
      immediate: true
    }
  },
  methods: {
    getData(num)
    {
      let paras1 = {cmd: 'queryUnion', _major: 99, _minor: 20, tables: 'A;B:99,19', cols: 'A:*;B:name', _exp: `A.moduleid = ${num}` + ' and A.moduleid=B.id'}
      window.post.getPost(paras1).then((ret) =>
      {
        this.tableData = []
        ret.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            glid: item.glid,
            colname: item.colname,
            dispc: item.dispc,
            name: item.name
          })
        })
      })
    },
    //删除
    delfn(row)
    {
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let params = {cmd: 'deletes', _major: 99, _minor: 20, ids: row}
        window.post.getPost(params).then((res) =>
        {
          if (typeof row === 'number')
          {
            let index = this.tableData.findIndex(e => e.id === row)
            this.tableData.splice(index, 1)
          }
          else
          {
            let ids = row.split(',')
            ids.forEach(id =>
            {
              let index = this.tableData.findIndex(e => e.id === Number(id))
              this.tableData.splice(index, 1)
            })
          }
        })
        this.$message({message: '删除成功!', type: 'success'})
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info'})
      })
    },
    //批量删除
    batchDelete()
    {
      let ids = Array.from(this.tempId, e => e).join(',')
      this.delfn(ids)
    },
    // 动态刷新列表页数据
    handleClick(tab)
    {
      if (tab.index === '1')
        this.$refs.child.getList()
    },
    //添加下拉值
    onSubmit(obj)
    {
      let params =
      {
        cmd: 'add',
        _major: 99,
        _minor: 20,
        retAtt: 1,
        moduleid: this.curID,
        dispc: obj.dispc,
        colname: obj.value,
        major: 11,
        minor: this.minor,
        glid: obj.parentdispc || 0
      }
      window.post.getPost(params).then(res =>
      {
        if (res instanceof Object)
        {
          this.dialogVisible = false
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.selectList = [{value: 'catid', name: '所属分类', parentdispc: '', dispc: '', tableData: []}]
          setTimeout(() => this.getData(this.curid), 50) // 刷新列表
        }
      })
    },
    // 取消
    cancle()
    {
      this.dialogVisible = false
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/Classification.vue